import { cn } from '@/lib/utils'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip'
import useAbility from '@/hooks/use-ability'
import { siteConfig } from '@/config/site'
import { useNavigate } from 'react-router-dom'

export interface IconIsze {
  width: number
  height: number
}

interface UpgradeLockIconProps {
  show: boolean
  title?: string
  className?: string
  position?: string
  onClick?: () => void
  iconSize?: IconIsze
}

export default function UpgradeLockIconLayout({
  position,
  show,
  title,
  className,
  iconSize,
}: UpgradeLockIconProps) {
  const navigate = useNavigate()
  const isTutorialPage = window.location.pathname === '/tutorial'
  const { isLoading } = useAbility()
  if (isTutorialPage) return null
  if (!show) return null
  const authData = localStorage.getItem('auth')
  const isDemoUser =
    authData &&
    JSON.parse(authData).sessionKey === 'a6cf9f6e-3341-4996-8d6a-83e826b67adf'
  if (isDemoUser) return null
  if (isLoading) return null

  return (
    <div className={cn('absolute z-10 w-full h-full ', position)}>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div
              className={cn(
                'cursor-pointer min-h-[24px] w-full flex items-center justify-start bg-white',
                className
              )}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                navigate(siteConfig.upgradeUrl)
              }}
              title={title}
            >
              <img
                width={iconSize?.width ?? 16}
                height={iconSize?.height ?? 16}
                src="icons/lock.svg"
                alt="Lock Icon"
              />
            </div>
          </TooltipTrigger>
          <TooltipContent className="bg-[#000000] text-[12px] text-white">
            Upgrade Plan
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}

export const LockToolTipIcon = ({
  show,
  className,
}: {
  show: boolean
  className: string
}) => {
  const navigate = useNavigate()
  const { isLoading } = useAbility()

  if (!show) return null
  if (isLoading) return null

  const authData = localStorage.getItem('auth')
  const isDemoUser =
    authData &&
    JSON.parse(authData).sessionKey === 'a6cf9f6e-3341-4996-8d6a-83e826b67adf'
  if (isDemoUser) return null
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={cn(
              'cursor-pointer min-h-[20px] flex items-center justify-start bg-white opacity-95',
              className
            )}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              navigate(siteConfig.upgradeUrl)
            }}
          >
            <img width={16} height={16} src="icons/lock.svg" alt="Lock Icon" />
          </div>
        </TooltipTrigger>
        <TooltipContent className="bg-[#000000] text-[12px] text-white">
          Upgrade Plan
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
